module.exports = __webpack_public_path__ + "static/media/dz.0477e542.svg";